"use client";

import React from "react";
import Link from "next/link";
import { useSearchParams, usePathname } from "next/navigation";
import { useCart } from "@/src/contexts/CartContext";

// ── Free-delivery threshold ───────────────────────────────────────────────────
// Change this single constant to update the threshold across the whole banner.
// const FREE_DELIVERY_THRESHOLD = 499;

export const FloatingCart: React.FC = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const prefix = searchParams.get("prefix") || "";
  const { getItemCount, getTotal } = useCart();

  const totalItems = getItemCount();
  const totalPrice = getTotal();

  if (totalItems === 0) return null;
  if (pathname.includes("/checkout") || pathname.includes("/profile") || pathname.includes("/orders") || pathname.includes("/subscriptions")) return null;

  // ── Progress toward free delivery ─────────────────────────────────────────
  // Clamp between 0–100 so the bar never overflows.
  // const progressPercent = Math.min((totalPrice / FREE_DELIVERY_THRESHOLD) * 100, 100);
  // const amountLeft = Math.max(FREE_DELIVERY_THRESHOLD - totalPrice, 0);
  // const hasReachedThreshold = totalPrice >= FREE_DELIVERY_THRESHOLD;

  return (
    <div
      className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2"
      style={{ width: "min(560px, calc(100% - 32px))" }}
    >
      <div
        className="rounded-2xl p-3.5 pl-[18px]"
        style={{
          background: "#F26250",
          color: "#fff",
          boxShadow:
            "0 16px 48px rgba(20,35,18,0.35), 0 2px 0 rgba(255,255,255,0.05) inset",
        }}
      >
        {/* Top row — item count, total, view-cart CTA */}
        <div className="flex items-center gap-3.5">
          {/* Cart icon */}
          <div
            className="flex shrink-0 items-center justify-center rounded-xl"
            style={{ width: 40, height: 40, background: "rgba(255,255,255,0.12)" }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
              <path d="M3 6h18" />
              <path d="M16 10a4 4 0 01-8 0" />
            </svg>
          </div>

          {/* Info */}
          <div className="flex flex-1 min-w-0 flex-col gap-0.5">
            <span className="text-sm font-bold leading-none tracking-[-0.2px]">
              {totalItems} item{totalItems !== 1 ? "s" : ""} added
            </span>
            <span className="text-[11.5px] font-medium opacity-75">
              Total · ₹{totalPrice}
            </span>
          </div>

          {/* CTA */}
          <Link
            href={`/shop/checkout${prefix ? `?prefix=${prefix}` : ""}`}
            className="shrink-0 flex items-center gap-1.5 rounded-full px-4 py-2.5 text-[13.5px] font-bold transition"
            style={{ background: "#fff", color: "#F26250" }}
            onMouseEnter={e => (e.currentTarget.style.transform = "translateX(2px)")}
            onMouseLeave={e => (e.currentTarget.style.transform = "")}
          >
            View Cart
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
              <path d="M5 12h14M13 5l7 7-7 7" />
            </svg>
          </Link>
        </div>

        {/* ── Free-delivery progress section ──────────────────────────────── */}
        {/* Divider between top row and progress row */}
        {/* <div style={{ height: 1, background: "rgba(255,255,255,0.15)", margin: "10px 0 8px" }} />

        <div className="flex items-center gap-2 mb-2">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, opacity: 0.9 }}>
            <rect x="1" y="3" width="15" height="13" rx="1" />
            <path d="M16 8h4l3 5v4h-7V8z" />
            <circle cx="5.5" cy="18.5" r="2.5" />
            <circle cx="18.5" cy="18.5" r="2.5" />
          </svg>

          <span className="text-[12px] font-medium" style={{ opacity: 0.9 }}>
            {hasReachedThreshold ? (
              <>🎉 You've unlocked <strong>FREE delivery!</strong></>
            ) : (
              <>Add <strong>₹{amountLeft}</strong> more for <strong>FREE delivery</strong></>
            )}
          </span>
        </div>

        <div
          className="overflow-hidden rounded-full"
          style={{
            height: 5,
            background: "rgba(255,255,255,0.22)",
          }}
        >
          <div
            style={{
              height: "100%",
              width: `${progressPercent}%`,
              background: "#fff",
              borderRadius: "9999px",
              transition: "width 500ms cubic-bezier(0.34, 1.56, 0.64, 1)",
            }}
          />
        </div> */}
        {/* ── End free-delivery progress section ─────────────────────────── */}
      </div>
    </div>
  );
};
